// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".webhooks-container[data-v-a5d819ac]{background-color:var(--v-background-base,#f5f5f5);min-height:100vh}.theme--dark .webhooks-container[data-v-a5d819ac]{background-color:#121212!important}", ""]);
// Exports
module.exports = exports;
